export default __webpack_public_path__ + "static/media/person_4.41471795.jpg";